var $000e668e4e84b579$exports = {};
$000e668e4e84b579$exports = {
    "longPressMessage": `Dugo pritisnite ili pritisnite Alt + strelicu prema dole da otvorite meni`
};


export {$000e668e4e84b579$exports as default};
//# sourceMappingURL=sr-SP.mjs.map
